// Mock data for school website

export const SCHOOL_INFO = {
  name: "Древо Познаний",
  tagline: "Частная школа с индивидуальным подходом",
  phone: "+7 (916) 122-21-12",
  whatsapp: "+79161222112",
  email: "Drevop@ya.ru",
  address: "г. Раменское, Красноармейская 105",
  schedule: "Понедельник - Пятница с 8:30 до 20:00",
  mapUrl: "https://yandex.ru/maps/10750/ramenskoe/house/krasnoarmeyskaya_ulitsa_105/Z0EYdAFiSEMAQFtvfXl3eX5kZw==/?ll=38.262168%2C55.568273&z=17",
  mapEmbedUrl: "https://yandex.ru/map-widget/v1/?ll=38.262168%2C55.568273&z=17&l=map&pt=38.262168,55.568273,pm2rdm",
  social: {
    vk: "https://vk.com/drevopoznaniy_ramenskoe",
    telegram: "https://t.me/Drevopoznaniy_ramenskoe",
    instagram: "https://www.instagram.com/drevopoznaniy_ramenskoe/"
  }
};

export const HERO = {
  headline: "Частная школа в Раменском «Древо Познаний»",
  subtext: "Обучение с 1 по 11 класс. Подготовка к ЕГЭ и ОГЭ с гарантированным результатом. Небольшие классы до 12 человек. Опытные преподаватели.",
  ctaPrimary: "Записаться на пробный день",
  ctaSecondary: "Узнать больше",
  image: "/images/home/hero-school.webp"
};

export const ABOUT = {
  title: "О нашей школе",
  mission: "Мы создаем образовательную среду, где каждый ученик получает персональное внимание и поддержку. Наша цель — не просто подготовить к экзаменам, но и воспитать любовь к знаниям.",
  vision: "«Древо Познаний» — это место, где дети учатся мыслить критически, работать самостоятельно и достигать высоких результатов. Мы верим, что качественное образование доступно каждому.",
  image: "/images/home/about-school.webp"
};

export const SCHOOL_LIFE = [
{
  id: 1,
  image: "/images/mock/mock-1.jpg",
  title: "Интерактивные занятия",
  description: "Современные методы обучения в малых группах",
  imagePosition: "object-center"
},
{
  id: 2,
  image: "/images/mock/mock-2.jpg",
  title: "Праздники и достижения",
  description: "Отмечаем успехи каждого ученика",
  imagePosition: "object-center"
},
{
  id: 3,
  image: "/images/mock/mock-3.jpg",
  title: "Творческое развитие",
  description: "Раскрываем потенциал через искусство",
  imagePosition: "object-[center_40%]"
},
{
  id: 4,
  image: "/images/mock/mock-4.jpg",
  title: "Более 20 элективных дисциплин",
  description: "Включая: кулинарную мастерскую, испанский язык, киноклуб на английском, интеллектуальный клуб, настольный теннис и другие",
  imagePosition: "object-center"
}];


export const ADVANTAGES = [
{
  id: 1,
  title: "Небольшие классы до 12 человек",
  description: "До 12 человек в классе — преподаватель уделяет внимание каждому ученику",
  icon: "users"
},
{
  id: 2,
  title: "Опытные педагоги",
  description: "Наши учителя — эксперты ЕГЭ и ОГЭ с многолетним опытом и высокими результатами",
  icon: "award"
},
{
  id: 3,
  title: "Высокие результаты",
  description: "97% наших выпускников поступают в ведущие вузы страны",
  icon: "trophy"
},
{
  id: 4,
  title: "Современный подход",
  description: "Интерактивные методы обучения, цифровые технологии и актуальные материалы",
  icon: "lightbulb"
}];


export const COURSES = [
{
  id: 1,
  title: "Подготовка к ЕГЭ",
  description: "Комплексная подготовка по всем предметам ЕГЭ. Индивидуальные планы обучения и регулярное тестирование.",
  icon: "graduationCap",
  subjects: ["Математика", "Русский язык", "Физика", "Химия", "История", "Обществознание"]
},
{
  id: 2,
  title: "Подготовка к ОГЭ",
  description: "Эффективная подготовка к ОГЭ для 9 классов. Систематизация знаний и отработка заданий.",
  icon: "bookOpen",
  subjects: ["Математика", "Русский язык", "Английский язык", "Физика", "Биология"]
},
{
  id: 3,
  title: "Дополнительные предметы",
  description: "Углубленное изучение предметов для школьников 5-11 классов. Ликвидация пробелов в знаниях.",
  icon: "book",
  subjects: ["Английский язык", "Программирование", "Литература"]
},
{
  id: 4,
  title: "Выходные интенсивы",
  description: "Тематические интенсивы по сложным темам. Решение олимпиадных задач и подготовка к конкурсам.",
  icon: "calendar",
  subjects: ["Олимпиадная математика", "Физика", "Программирование"]
}];


export const STATS = [
{
  id: 1,
  value: 87,
  label: "Средний балл ЕГЭ",
  suffix: ""
},
{
  id: 2,
  value: 4.68,
  label: "Средний балл ОГЭ",
  suffix: ""
},
{
  id: 3,
  value: 97,
  label: "Поступили в государственные вузы",
  suffix: "%"
},
{
  id: 4,
  value: 3,
  label: "Поступили в международные вузы",
  suffix: "%"
},
{
  id: 5,
  value: 15,
  label: "Медалистов за последние 3 года",
  suffix: ""
},
{
  id: 6,
  value: 240,
  label: "Выпускников",
  suffix: "+"
}];


export const TEACHERS = [
{
  id: 1,
  name: "Полина Фёдоровна",
  subject: "Математика",
  bio: "«Математика — это не просто цифры, это способ мышления и ключ к успеху»",
  motto: "",
  image: null
},
{
  id: 2,
  name: "Михаил Иванович",
  subject: "Физика",
  bio: "«Делаю физику понятной и увлекательной для каждого ученика»",
  motto: "",
  image: null
},
{
  id: 3,
  name: "Mr. Alejandro",
  subject: "Информатика и Английский язык",
  bio: "«Раскрываю потенциал через технологии и языки — готовлю к глобальному будущему»",
  motto: "",
  image: null
},
{
  id: 4,
  name: "Елена Анатольевна",
  subject: "Начальная школа",
  bio: "«Тот первый учитель, которого дети вспоминают с теплом всю жизнь»",
  motto: "",
  image: null
},
{
  id: 5,
  name: "Наталия Владимировна",
  subject: "Начальная школа",
  bio: "«Создаю атмосферу, где каждый ребёнок чувствует себя особенным»",
  motto: "",
  image: null
}];


export const TESTIMONIALS = [
{
  id: 1,
  name: "Родитель",
  role: "Мама ученика 1 класса",
  type: "parent",
  text: "Вот и пролетел первый год в нашей школе. На одном дыхании и для нас, родителей, и для ребёнка. Интересные уроки мотивируют и завлекают. Английский с мистером Алехандро раскрыл потенциал о котором я даже не догадывалась))) а наша Елена Анатольевна, тот ПЕРВЫЙ учитель, которого дети будут вспоминать с большим теплом. Ну а сделанные в школе уроки - это бесценно)))) С огромной благодарностью ко всем учителям и администрации. Ждём осени))))",
  image: "https://images.unsplash.com/photo-1758874960777-931053e0d9c6?crop=entropy&cs=srgb&fm=jpg&q=85",
  rating: 5
},
{
  id: 2,
  name: "Родитель",
  role: "Мама ученика",
  type: "parent",
  text: "Потрясающая школа. Ребенок будет учиться третий год, ему очень нравится. Учителя замечательные! Атмосфера как большая семья. Обучение направлено, чтобы вызвать у детей интерес к учебе, а не как в других школах. Это огромный плюс. Ребенок с радостью посещает школу и если заболеет грустит, что пропускает учебу. Обучение в «древо познаний» это как ежедневный праздник для детей. В общем, отдав ребенка сюда вы ни на секунду не пожалеете, что сделали выбор в пользу древо познаний! Однозначно рекомендую",
  image: "https://images.unsplash.com/photo-1739208683712-c83480a79302?crop=entropy&cs=srgb&fm=jpg&q=85",
  rating: 5
},
{
  id: 3,
  name: "Родитель",
  role: "Мама выпускника",
  type: "parent",
  text: "Огромное спасибо преподавателям, за один год смогли подготовить моего сына к сдаче ОГЭ. Были пробелы в знаниях, всё было успешно восстановлено. Огромная благодарность учителям Математики, Русского языка и Информатики. Сын успешно сдал все экзамены и перешёл в 10 класс. Надеюсь, что воспользуемся репетиторами для сдачи ЕГЭ",
  image: "https://images.unsplash.com/photo-1518800431428-69a992a6f54a?crop=entropy&cs=srgb&fm=jpg&q=85",
  rating: 5
},
{
  id: 4,
  name: "Родитель",
  role: "Мама выпускника",
  type: "parent",
  text: "Сын закончил школу Древо познаний в прошлом году. Остались очень тёплые, хорошие воспоминания. Школа дала не только глубокие знания (поступил на бюджет в тот ВУЗ, в который планировал), но и сама атмосфера была очень дружелюбной, по семейному тёплой. Много разнообразных элективных занятий из которых каждый может выбрать то, что ему ближе и интереснее",
  image: "https://images.pexels.com/photos/11867557/pexels-photo-11867557.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rating: 5
},
{
  id: 5,
  name: "Родитель",
  role: "Мама ученика 8 класса",
  type: "parent",
  text: "Сын учится в 8 классе, пришли в 6 классе. Индивидуальный подход к каждому ребенку, система образования устроена так, что предметы даются более углубленно, прекрасный преподавательский состав и административный. Директор школы Елена Александровна всегда доступна для каждого родителя. Сын и в подростковом возрасте идет с радостью каждый день. Всем у кого есть возможность рекомендую данную школу для качественного образования ребенка. Дополнительные занятия не требуются идет целенаправленная подготовка для поступления в ВУЗ. Очень довольна, что дома не надо контролировать уроки, это делают в школе. Организовано питание и досуг! 💕🌹🌹🌹",
  image: "https://images.pexels.com/photos/10332821/pexels-photo-10332821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rating: 5
}];


// Mock form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      localStorage.setItem(
        `contact_${Date.now()}`,
        JSON.stringify(formData)
      );
      resolve({
        success: true,
        message: "Спасибо! Мы свяжемся с вами в ближайшее время."
      });
    }, 800);
  });
};
